import axios from '@/libs/axios'

const endpoint = 'uz-asbo'

const list = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/lists/`, { params: queryParams })
    .then(response => {
      commit('LIST', response.data.results || response.data)
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})

const get = ({ commit }, id) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/lists/${id}/`)
    .then(response => {
      commit('GET', response.data)
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})

// Tashkilot admini
const create = (_, data) => axios.post(`/${endpoint}/lists/`, {
  year: data.year,
  month: data.month,
})

const del = (_, data) => axios.delete(`/${endpoint}/lists/${data.id}/`)

const candidates = (_, id) => axios.get(`/${endpoint}/lists/${id}/candidates/`)

const addItem = (_, data) => axios.post(`/${endpoint}/lists/${data.id}/add-item/`, {
  apply_doc_id: data.applyDocId,
})

const removeItem = (_, data) => axios.delete(`/${endpoint}/lists/${data.id}/remove-item/`, {
  params: { item_id: data.itemId },
})

const send = (_, id) => axios.post(`/${endpoint}/lists/${id}/send/`, {})

// Tashkilot ma'sul rahbari
const approve = (_, data) => axios.post(`/${endpoint}/lists/${data.id}/approve/`, {
  comment: data.comment || '',
})

const reject = (_, data) => axios.post(`/${endpoint}/lists/${data.id}/reject/`, {
  comment: data.comment,
})

const payload = (_, id) => axios.get(`/${endpoint}/lists/${id}/payload/`)

const sign = (_, data) => axios.post(`/${endpoint}/lists/${data.id}/sign/`, {
  signature: data.signature,
  signature_info: data.signatureInfo,
})

// Innovatsion rivojlanish agentligi
const innovationReject = (_, data) => axios.post(`/${endpoint}/lists/${data.id}/innovation-reject/`, {
  comment: data.comment,
})

const monthlyOrganizations = ({ commit }, queryParams) => new Promise((resolve, fail) => {
  axios.get(`/${endpoint}/monthly/organizations`, { params: queryParams })
    .then(response => {
      commit('MONTHLY', response.data)
      resolve(response)
    })
    .catch(error => {
      fail(error)
    })
})

const monthlyItems = ({ commit }, queryParams) => new Promise((resolve, fail) => {
  axios.get(`/${endpoint}/monthly/items`, { params: queryParams })
    .then(response => {
      commit('LIST', response.data.results || response.data)
      resolve(response)
    })
    .catch(error => {
      fail(error)
    })
})

const batchList = (_, queryParams) => axios.get(`/${endpoint}/batches/`, { params: queryParams })

const batchApprove = (_, data) => axios.post(`/${endpoint}/batches/approve/`, {
  year: data.year,
  month: data.month,
})

const batchSend = (_, data) => axios.post(`/${endpoint}/batches/send/`, {
  year: data.year,
  month: data.month,
})

export default {
  list,
  get,
  create,
  del,
  candidates,
  addItem,
  removeItem,
  send,
  approve,
  reject,
  payload,
  sign,
  innovationReject,
  monthlyOrganizations,
  monthlyItems,
  batchList,
  batchApprove,
  batchSend,
}
